<div #panel class="panel-box">
  <div p-panel>
    <div p-header>
      <ng-content select="[header]"> </ng-content>
    </div>
    <div class="content-box">
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
</div>
